// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperPreviewList-cls1_lq4","cls2":"PaperPreviewList-cls2_2ut PaperPreviewList-cls1_lq4","spin":"PaperPreviewList-spin_dFD"};